/**
 * @license
 * Taken from https://github.com/acdlite/recompose
 * The MIT License (MIT)
 * Copyright (c) 2015-2016 Andrew Clark
 */
/**
 * @license
 * Taken from https://github.com/acdlite/recompose
 * The MIT License (MIT)
 * Copyright (c) 2015-2016 Andrew Clark
 */ export var isClassComponent = function (Component) { return Boolean(Component &&
    Component.prototype &&
    typeof Component.prototype.isReactComponent === "object"); };
export default isClassComponent;

//# sourceMappingURL=isClassComponent.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/utils/isClassComponent.js
// module id = 66
// module chunks = 0